import { rd } from '@passionware/monads';
import { CustomFieldTypeIcon } from 'v5/patterns/widgets/customFieldTypeIcons';
import { CustomFieldDefinition, CustomFieldType } from '__types__';
import { EnumFilterDisplayValue } from 'v5/patterns/filters/EnumFilterWidget';
import { FilterEnumConfig } from 'v5/patterns/filters/FilterWidget.types';

function convertCustomFieldOptionToDisplayValue(option: {
  id: number;
  value: string;
}): EnumFilterDisplayValue<string> {
  return {
    value: option.value,
    label: option.value
  };
}

export function createEnumFilterConfig(
  customFieldDef: CustomFieldDefinition
): FilterEnumConfig<string> {
  const valueType =
    customFieldDef.data_type === CustomFieldType.MULTI_SELECT
      ? 'array'
      : 'scalar';

  return {
    label: customFieldDef.name,
    icon: <CustomFieldTypeIcon type={customFieldDef.data_type} />,
    type: 'enum' as const,
    createDefaultValue: () => ({ operator: 'matchAny', value: [] }),
    options: {
      useValues: (values: string[]) => {
        // For selected values, filter from the field's options
        const selectedOptions = customFieldDef.options.filter(option =>
          values.includes(option.value)
        );
        return rd.of(
          selectedOptions.map(convertCustomFieldOptionToDisplayValue)
        );
      },
      useOptions: (query: string) => {
        // For search options, filter the field's options by query
        let filteredOptions = customFieldDef.options;
        if (query.trim()) {
          const normalizedQuery = query.trim().toLowerCase();
          filteredOptions = customFieldDef.options.filter(option =>
            option.value.toLowerCase().includes(normalizedQuery)
          );
        }
        return rd.of(
          filteredOptions.map(convertCustomFieldOptionToDisplayValue)
        );
      },
      valueType
    }
  };
}
